import { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

const seatParams = (toSeatsioObjectId) => ({ to_seatsio_object_id: toSeatsioObjectId });

export default function useOrderSeatReassignment({
  csrfToken, url, previewUrl, onReassigned, toParams = seatParams, successMessage = 'Seat changed', failureMessage = 'Could not change the seat. Please try again.',
}) {
  const [ticket, setTicket] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const openFor = (selectedTicket) => setTicket(selectedTicket);
  const close = () => setTicket(null);

  const submit = (destination, paymentMethod = null, expectedTotal = null, refundAmount = null) => {
    setSubmitting(true);
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    return axios.post(url, {
      ticket_id: ticket.id,
      seat_reassignment: { ...toParams(destination), payment_method: paymentMethod, expected_total: expectedTotal },
    })
      .then(() => {
        toast.success(successMessage, { position: toast.POSITION.TOP_CENTER, hideProgressBar: true });
        setTicket(null);
        if (onReassigned) onReassigned({ ticket, refundAmount });
      })
      .catch((error) => {
        const data = error.response && error.response.data;
        const message = data && data.errors ? [].concat(data.errors).join(', ') : failureMessage;
        toast.error(message, { position: toast.POSITION.TOP_CENTER, hideProgressBar: true });
      })
      .then(() => setSubmitting(false));
  };

  const preview = (destination) => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    return axios.post(previewUrl, { ticket_id: ticket.id, seat_reassignment: toParams(destination) })
      .then((response) => response.data);
  };

  return { ticket, openFor, close, submitting, submit, preview };
}
